module.exports = __webpack_public_path__ + "img/yasmaniacosta.d1ac36be.jpg";